


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { MmCreateTaskResponse } from '../../types/dto';
import { MmTaskType } from '../../types/enums';
import TaskCreate from './TaskCreate.vue';
import { getTaskTypeProfile } from './taskTypeProfile';

const KEY = 'priceMonitoring.mobileMonitoring.taskForm.';

@Component({
	components: { TaskCreate },
})
export default class TaskCreateModal extends Vue {
	@Prop({ default: false }) readonly visible!: boolean;

	@Prop({ default: null }) readonly initialType!: MmTaskType | null;

	@Prop({ default: null }) readonly tradingId!: number | null;

	@Prop({ default: false }) readonly isActive!: boolean;

	/** Поле, а не вычисляемое: форма может восстановить тип из черновика, заголовок обязан назвать его */
	currentType: MmTaskType | null = null;

	@Watch('initialType', { immediate: true })
	onInitialTypeChanged(next: MmTaskType | null): void {
		this.currentType = next;
	}

	/** Видимость умножаем на isActive: окно уходит порталом в body и висело бы поверх соседней вкладки */
	get isDialogVisible(): boolean {
		return this.visible && this.isActive;
	}

	get modalTitle(): string {
		const profile = getTaskTypeProfile(this.currentType);

		if (profile === null) {
			return this.$t(KEY + 'createTitle') as string;
		}

		return this.$t(KEY + 'createTitleTyped', { type: this.$t(profile.labelKey) }) as string;
	}

	get modalWidth(): number {
		const profile = getTaskTypeProfile(this.currentType);

		return profile !== null && profile.hasProductsTable ? 1000 : 800;
	}

	handleTypeChange(type: MmTaskType | null): void {
		this.currentType = type;
	}

	/** Закрываем через форму: там стирается черновик, иначе он всплывёт при следующем открытии */
	handleCancel(): void {
		const form = this.$refs.form as any;

		if (form && form.isSubmitting === true) {
			return;
		}

		if (form && typeof form.handleBack === 'function') {
			form.handleBack();

			return;
		}

		this.$emit('close');
	}

	handleFormBack(): void {
		this.$emit('close');
	}

	handleCreated(body: MmCreateTaskResponse | null): void {
		this.$emit('created', body);
	}

	handleGoToAssignments(): void {
		this.$emit('go-to-assignments');
	}
}
